<template>
  <b-container class="bv-example-row forms">
    <h4 class="titulo center">Adicionar Palestrante</h4>
    <b-form @submit="onSubmit">
      <b-row>
        <b-col sm="5" class="right">
          <div id="botaoAdicionar">
            <div id="preview right">
              <img v-if="url" :src="url" />
            </div>
            <div class="upload-btn-wrapper">
              <button type="button" class="btnImg" @click="onClickAddImg">
                Adicionar Imagem
              </button>

              <input
                class="invisible"
                ref="inputImg"
                type="file"
                name="foto"
                @change="onFileChange"
              />
            </div>
          </div>
        </b-col>

        <b-col sm="4" class="forms-input">
          <!-- input nome -->
          <b-form-group
            id="input-group-nome"
            label="Nome do Palestrante"
            label-for="input-nome"
          >
            <b-form-input
              id="input-nome"
              v-model="form.name"
              type="text"
              required
            ></b-form-input>
          </b-form-group>

          <!-- input instituição -->
          <b-form-group
            id="input-group-instituicao"
            label="Instituição"
            label-for="input-instituicao"
          >
            <b-form-input
              id="input-instituicao"
              v-model="form.institution"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
          <b-button
            class="btnEnviar"
            :disabled="!form.photo"
            type="submit"
            variant="primary"
            >Salvar</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import {
  novoPalestrante,
  palestranteById,
  updatePalestrante,
} from "@/services/api/Palestrantes";

export default {
  data() {
    return {
      url: "https://picsum.photos/id/1005/600/200",
      idPalestrante: undefined,
      form: {
        name: "",
        institution: "",
        photo: "",
      },
      show: true,
    };
  },
  created() {
    if (this.$route.params.idPalestrante) {
      this.idPalestrante = this.$route.params.idPalestrante;
      palestranteById(this.idPalestrante).then((res) => {
        this.form = res.data;
        this.form.speaker = this.form.speaker._id;
        this.url = this.form.photo;
        this.form.photo = undefined;
      });
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      console.log(this.form);
      if (this.idPalestrante) {
        updatePalestrante(this.form)
          .then(() => {
            this.$router.push("/admin/palestrantes");
          })
          .catch((error) => {
            console.error("erro ao atualizar palestrante", error.response);
          });
      } else {
        novoPalestrante(this.form)
          .then(() => {
            this.$router.push("/admin/palestrantes");
          })
          .catch((error) => {
            console.error("erro ao salvar palestrante", error.response);
          });
      }
    },
    onClickAddImg() {
      this.$refs.inputImg.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.form.photo = file;
    },
    setFile(input) {
      console.log("deubom", input.target.files[0]);
      this.form.photo = input.target.files[0];
    },
  },
};
</script>

<style scoped>
.titulo {
  margin-bottom: 3%;
  margin-left: -275px;
  font-weight: 400;
  letter-spacing: 0.4px;
}

#preview {
  max-width: 125px;
  max-height: 125px;
}

img {
  border-radius: 50%;
  height: 125px;
  width: 125px;
  margin-bottom: 3%;
  object-fit: cover;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
}

.btnImg {
  color: black;
  background: transparent linear-gradient(270deg, #ff0000 0%, #ffc107 100%) 0%
    0% no-repeat padding-box;
  border-radius: 6px;
  height: 28px;
  width: 125px;
  border: 2px solid transparent;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.btnEnviar {
  color: black;
  background: transparent linear-gradient(270deg, #ff0000 0%, #ffc107 100%) 0%
    0% no-repeat padding-box;
  border-radius: 28px;
  width: 150px;
  border: 0px solid transparent;
  margin-top: 25%;
  font-weight: 500;
  cursor: pointer;
  z-index: 99;
}

.invisible {
  display: none;
}

.center {
  text-align: center;
}

.right {
  text-align: right;
}

.left {
  text-align: left;
}

.forms {
  padding-top: 8%;
  font-weight: 500;
  font-family: Roboto;
}

#input-group-nome {
  margin-bottom: 0.7rem;
}

input {
  margin-top: -5px;
  width: 85%;
  height: 32px;
  border: 1px solid #ee3824;
  border-radius: 4px;
  font-family: roboto;
}

input:focus {
  border: 0px solid #ee3824;
}
</style>
